import * as signalR from "@microsoft/signalr";
// export default function Signalr(setSensorDataArray?: any) {
export default function BloodOxygenHub(props: {
    sn?: string,
    setBloodOxygenData?: Function
}) {
    const {
        sn,
        setBloodOxygenData: setBloodOxygenData,
    } = props;
    //TODO
    let connection = new signalR.HubConnectionBuilder().withUrl(`${process.env.REACT_APP_BASE_URL}bloodOxygen`).build();
    connection.start().then(() => {
        // console.log("started", sn, "BloodOxygenHub");
        connection.invoke("SubscribeToBloodOxygenData", sn);
    }).catch((err: any) => {
        return console.error(err.toString());
    });

    connection.on("ReceiveSensorData", (data: any) => {
        // console.log("sn: " + sn + ", data: ", data);
        setBloodOxygenData && setBloodOxygenData([data]); // Update the data array or object

    });

    return () => {
        connection.stop();
    };
}